import React from "react"
import discord from "../../assets/discordfooter.png"
import "./index.css"

const Footer = props => (
  <footer>
    <a href={"https://discord.gg/THY7A5v"}>
      <img src={discord} alt={"Join the Chat Discord"} />
    </a>
    
    
    <div class="footer-copyright text-right">© 2020 Copyright:
    <a href="https://premium-studios.com/"> Premium-Studios.com</a>
  </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js